<template>
    <v-card-title class="justify-center primary white--text">
        <slot />
    </v-card-title>
</template>

<script>
export default {};
</script>
